import removeFromDateOSU from './education/v6/removeFromDateOSU';
import updateTetraMode from './getUserPreferences/v6/updateTetraMode';
import removeEmptyParagraphOrg from './skills/v4/removeEmptyPara';

export default (params) => {
  const { fieldType } = params;

  if (
    fieldType === 'projects' ||
    fieldType === 'associations' ||
    fieldType === 'leadership' ||
    fieldType === 'volunteerWork'
  ) {
    return removeEmptyParagraphOrg(params);
  }

  if (fieldType === 'userPreferences') {
    return updateTetraMode(params);
  }

  if (fieldType === 'education') {
    return removeFromDateOSU(params);
  }

  return null;
};
